import { render, staticRenderFns } from "./buy-cursos.vue?vue&type=template&id=f06f97c6&scoped=true"
import script from "./buy-cursos.vue?vue&type=script&lang=js"
export * from "./buy-cursos.vue?vue&type=script&lang=js"
import style0 from "./buy-cursos.vue?vue&type=style&index=0&id=f06f97c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06f97c6",
  null
  
)

export default component.exports